import type { SlideProps } from "@/engine/app/offsite-config";

const TILES = [
  { title: "Frühwarnsystem", text: "Erkennt Anomalien, bevor sie zum Problem werden." },
  { title: "Kanal-Analyse", text: "Wo erreichen wir Kunden wirklich?" },
  { title: "Saisonale Vorbereitung", text: "Kapazitäten dort, wo sie gebraucht werden." },
];

export function Slide18Datalake(_: SlideProps) {
  return (
    <div className="deck-root dark" style={{ background: "var(--svo-dunkelblau)" }}>
      <div className="deck-bg" aria-hidden="true" />

      <header className="deck-head">
        <div className="deck-eyebrow rise rise-1">Datalake</div>
        <h1 className="deck-title rise rise-2">
          Von Daten zu <br />
          <span className="accent">Entscheidungen</span>
        </h1>
      </header>

      <div className="deck-cols3">
        {TILES.map((t, i) => (
          <div key={t.title} className={`col-card rise rise-${i + 4}`}>
            <div className="num">0{i + 1}</div>
            <h4>{t.title}</h4>
            <p>{t.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
